import { init } from "@module-federation/runtime";
import { useEffect, useState } from "react";

import { FederationState, RemotesManifest } from "types/federation";
import { extractRoutesFromManifest, extractVersionsFromManifest, getManifestUrl } from "utils/federation";
import { getSharedPackages } from "utils/getSharedPackages";

export function useFederationInit(): FederationState {
  const [state, setState] = useState<FederationState>({
    loading: true,
    routes: {},
    versions: {},
  });

  useEffect(() => {
    const initializeFederation = async () => {
      try {
        const manifestUrl = getManifestUrl();

        console.log("Loading manifest from:", manifestUrl);

        const response = await fetch(manifestUrl);

        if (!response.ok) {
          throw new Error(
            `Failed to fetch manifest: ${response.status} ${response.statusText}`
          );
        }

        const manifest: RemotesManifest = await response.json();
        const allRoutes = extractRoutesFromManifest(manifest);
        const versions = extractVersionsFromManifest(manifest);

        const remotes = manifest.remotes.map(remote => ({
          name: remote.name,
          entry: remote.entry,
          type: 'module',
          shareScope: 'default',
        }));

        init({
          name: 'app-shell',
          remotes,
          ...getSharedPackages(),
        });

        setState({
          loading: false,
          routes: allRoutes,
          versions: versions,
        });
      } catch (error) {
        console.error("Failed to initialize module federation:", error);
        setState({
          loading: false,
          routes: {},
          versions: {},
        });
      }
    };

    initializeFederation();
  }, []);

  return state;
}
